import { connect } from 'react-redux';
import {
  loadIpmaCisCreator,
  setIpmaCisPageCreator,
  setIpmaCisPerPageCreator,
  setIpmaCisSortCreator,
  setIpmaCisFiltersCreator,
  removeIpmaCisFiltersCreator,
  setIpmaCisProfileCreator,
  removeIpmaCisCreator,
} from 'store/actionsCreators';
import { isLoading } from 'helpers';
import CertificateHolders from '../../../../shared/Cis/CertificateHolders/CertificateHolders';
import { loadGlobalCisCertificateHoldersAttributesCreator } from '../../../../store/actionsCreators';

const mapStateToProps = ({ loading, ipma, user }) => ({
  loading: isLoading(loading, 'LOAD_IPMA_CIS'),
  type: 'ipma',
  list: ipma.cis.certificateHolders,
  userPermissions: user.userPermissions,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadIpmaCisCreator('certificateHolders')),
  setPage: (payload) => dispatch(setIpmaCisPageCreator('certificateHolders', payload)),
  setPerPage: (payload) => dispatch(setIpmaCisPerPageCreator('certificateHolders', payload)),
  setSort: (payload) => dispatch(setIpmaCisSortCreator('certificateHolders', payload)),
  setFilters: (payload) => dispatch(setIpmaCisFiltersCreator('certificateHolders', payload)),
  removeFilters: () => dispatch(removeIpmaCisFiltersCreator('certificateHolders')),
  setProfile: (payload) => dispatch(setIpmaCisProfileCreator('certificateHolders', payload)),
  removeCertificateHolder: (payload) =>
    dispatch(removeIpmaCisCreator('certificateHolders', payload)),
  setCertificatesFilters: (payload) => dispatch(setIpmaCisFiltersCreator('certificates', payload)),
  loadCertificateHoldersAttributes: () =>
    dispatch(loadGlobalCisCertificateHoldersAttributesCreator()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CertificateHolders);
